'use client';

import { createContext, useContext, useState } from 'react';

type GalleryContextType = {
  isOpen: boolean;
  openGallery: (index?: number) => void;
  closeGallery: () => void;
  initialIndex: number;
};

const GalleryContext = createContext<GalleryContextType | null>(null);

export function GalleryProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [initialIndex, setInitialIndex] = useState(0);

  const openGallery = (index = 0) => {
    setInitialIndex(index);
    setIsOpen(true);
  };

  const closeGallery = () => {
    setIsOpen(false);
  };

  return (
    <GalleryContext.Provider
      value={{ isOpen, openGallery, closeGallery, initialIndex }}
    >
      {children}
    </GalleryContext.Provider>
  );
}

export function useGallery() {
  const context = useContext(GalleryContext);
  if (!context) {
    throw new Error('useGallery must be used within a GalleryProvider');
  }
  return context;
}
